export const WebsiteImages = [
  "https://github.com/Raunak-Taabish/crypto_alert/blob/main/lib/home.jpg?raw=true",
  "https://cdn.dribbble.com/users/7412964/screenshots/17480970/media/10cc49cd53435fd468355d79b02b656b.png",
  "https://cdn.dribbble.com/users/2080514/screenshots/17471821/media/71bc61b2d3a7c7382993bfb79ba420e3.jpg",
  "https://cdn.dribbble.com/users/3636379/screenshots/17474202/media/7f91ede84ee77ec384dd2de4f3afa063.png",
];

export const technologies = [
  {
    techname: "Figma",
    uses: "To design the User Interface, Team meeting & Brainstorming",
    images: "https://miro.medium.com/max/1400/1*x33n87v9KyFflJ5qD2HabQ.png",
  },
  {
    techname: "Framer",
    uses: "To design & creating prototypes also provides animation library for ReactJS",
    images: "https://cdn.jim-nielsen.com/ios/512/framer-preview-2016-08-05.png",
  },
  {
    techname: "Firebase",
    uses: "To connect & configure database and realtime update",
    images:
      "https://www.gstatic.com/devrel-devsite/prod/v870be6fb6841f3532cd3aec5bc0b3146031642f2794ae8ba7f51ebf843a655f9/firebase/images/touchicon-180.png",
  },
  {
    techname: "Flutter",
    uses: "Allows to develope Native Android applications with flexible UI",
    images:
      "https://yt3.ggpht.com/ytc/AKedOLRt1d4p7bPylasq_66BIC8-k3hkyVjJ2JICQITK=s900-c-k-c0x00ffffff-no-rj",
  },
  {
    techname: "ReactJS",
    uses: "Is a Library to create UI for Webapplications",
    images:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png",
  },
  {
    techname: "Chakra UI",
    uses: "Is a component library that provides prebuilt components to accelerate Web-development",
    images:
      "https://itelofilho.gallerycdn.vsassets.io/extensions/itelofilho/chakra-ui-cheatsheet/0.1.2/1602346378840/Microsoft.VisualStudio.Services.Icons.Default",
  },
  {
    techname: "Tailwind CSS",
    uses: "Is a utility-first CSS framework for rapidly building custom user interfaces",
    images:
      "https://www.drupal.org/files/styles/grid-3-2x/public/project-images/screenshot_361.png?itok=w4CzcWyb",
  },
  {
    techname: "And Still Learning...",
  },
];
